import pluralize from "pluralize";
import React from "react";
import { Spacer } from "../../spacer";
import styles from "./portal_booking_step_2.module.css";
import { PortalBookingStepLayout } from "./portal_booking_step_layout";
import { PortalBookingSpaceDetails } from "./portal_booking_space_details";
import { UnitUsedDetails } from "./unit_used_details";
import { PortalBookingPriceDetails } from "./portal_booking_price_details";
import { FAKE_PAYMENT_DETAILS } from "../fake_data";
import { BookingType } from "../../../data";
import { useMediaQuery } from "../../../hooks";
import { Divider } from "../../divider";
import { isNumber } from "lodash";

interface PortalBookingStep2Props {
  imgUrl: string;
  location: string;
  bookingDate?: string | JSX.Element;
  capacity: number;
  usedCount: number;
  remainingCount?: number;
  spaceName: string;
  bookingType: BookingType;
  partnerId?: string;
  cancelPolicy?: string;
  isUnlimitedPlan?: boolean;
}

export function PortalBookingStep2({
  imgUrl,
  location,
  bookingDate,
  capacity,
  remainingCount,
  usedCount,
  spaceName,
  bookingType,
  partnerId,
  cancelPolicy,
  isUnlimitedPlan,
}: PortalBookingStep2Props) {
  const { device } = useMediaQuery();
  const isMobile = device === "mobile";

  const renderRightContent = () => {
    if (isUnlimitedPlan) {
      return (
        <UnitUsedDetails
          title={bookingType === BookingType.Daily ? "Day Passes" : "Hours"}
          usedCount={usedCount}
          description={`With your membership, book ${
            bookingType === BookingType.Daily ? "day" : "hour"
          } passes with no monthly limit.`}
        />
      );
    }

    if (isNumber(remainingCount)) {
      if (remainingCount >= 0) {
        return (
          <UnitUsedDetails
            title={
              bookingType === BookingType.Daily
                ? "Passes applied"
                : "Hours used"
            }
            usedCount={usedCount}
            description={`You will have ${remainingCount} remaining ${pluralize(
              bookingType === BookingType.Daily ? "pass" : "hour",
              remainingCount
            )} after placing this booking.`}
          />
        );
      } else {
        return (
          <PortalBookingPriceDetails
            {...FAKE_PAYMENT_DETAILS}
            hasActions
            partnerId={partnerId}
          />
        );
      }
    }
  };

  return (
    <PortalBookingStepLayout
      leftContent={
        <div>
          <div className={styles.title}>Confirm your booking</div>
          <Spacer size={24} />
          <div>
            <div className={styles.dayPassTitle}>{spaceName}</div>
            <Spacer size={16} />
            <PortalBookingSpaceDetails
              imgUrl={imgUrl}
              location={location}
              bookingDate={bookingDate}
              capacity={capacity}
            />
          </div>
          {!isMobile && cancelPolicy && (
            <div>
              <Spacer size={32} />
              <Divider />
              <Spacer size={32} />
              <div>
                <b>Cancellation policy</b>
                <Spacer size={16} />
                <div>{cancelPolicy}</div>
              </div>
            </div>
          )}
        </div>
      }
      rightContent={
        <div>
          {renderRightContent()}
          {isMobile && cancelPolicy && (
            <div>
              <Spacer size={24} />
              <Divider />
              <Spacer size={24} />
              <div>
                <b>Cancellation policy</b>
                <Spacer size={16} />
                <div>{cancelPolicy}</div>
              </div>
            </div>
          )}
        </div>
      }
    />
  );
}
